// ActiveAdmin Navigation Dropdown Enhancement
// This script ensures dropdown menus stay open when moving mouse between parent and submenu

document.addEventListener('DOMContentLoaded', function () {
  // Find all menu items that have submenus (parent items)
  function initializeDropdownFix() {
    const menuItems = document.querySelectorAll('#header ul.header-item li.menu_item')

    menuItems.forEach(function (menuItem) {
      const submenu = menuItem.querySelector('ul')

      if (submenu) {
        // This menu item has children - make it a dropdown
        menuItem.classList.add('has_nested_menu')

        let hoverTimeout

        // Show submenu on mouse enter
        menuItem.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimeout)
          submenu.style.display = 'block'
          submenu.style.opacity = '1'
          submenu.style.visibility = 'visible'
          submenu.style.transform = 'translateY(0)'
        })

        // Hide submenu on mouse leave with delay
        menuItem.addEventListener('mouseleave', function () {
          hoverTimeout = setTimeout(function () {
            submenu.style.opacity = '0'
            submenu.style.visibility = 'hidden'
            submenu.style.transform = 'translateY(-10px)'
            setTimeout(function () {
              submenu.style.display = 'none'
            }, 300)
          }, 100) // Small delay to allow mouse to move to submenu
        })

        // Keep submenu open when hovering over it
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimeout)
        })

        submenu.addEventListener('mouseleave', function () {
          hoverTimeout = setTimeout(function () {
            submenu.style.opacity = '0'
            submenu.style.visibility = 'hidden'
            submenu.style.transform = 'translateY(-10px)'
            setTimeout(function () {
              submenu.style.display = 'none'
            }, 300)
          }, 100)
        })
      }
    })
  }

  // Initialize on page load
  initializeDropdownFix()

  // Re-initialize when ActiveAdmin does AJAX updates
  document.addEventListener('page:loaded', initializeDropdownFix)
  document.addEventListener('turbo:load', initializeDropdownFix)

  // Also handle the specific case where ActiveAdmin might dynamically update the menu
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        const header = mutation.target.closest('#header')
        if (header) {
          initializeDropdownFix()
        }
      }
    })
  })

  const header = document.querySelector('#header')
  if (header) {
    observer.observe(header, { childList: true, subtree: true })
  }
})
